import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LegacySubscriptionExpiringResponse } from '../models/subscriptions/legacy-subscription-expiring-response.model';

const API_URL = `${environment.flyLegacyUrl}/api`;

@Injectable()
export class LegacySubscriptionsService {
  constructor(private readonly http: HttpClient) {}

  getUserExpiringLegacyAvdbSubscriptions(days: string): Observable<LegacySubscriptionExpiringResponse[]> {
    return this.http.get<LegacySubscriptionExpiringResponse[]>(
      `${API_URL}/legacy-subscriptions/avdb/expiring-in/${days}`
    );
  }
}
